import { render, staticRenderFns } from "./permissionTreeDialog.vue?vue&type=template&id=b4308c60&scoped=true"
import script from "./permissionTreeDialog.vue?vue&type=script&lang=js"
export * from "./permissionTreeDialog.vue?vue&type=script&lang=js"
import style0 from "./permissionTreeDialog.vue?vue&type=style&index=0&id=b4308c60&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4308c60",
  null
  
)

export default component.exports